export const REPORT_PROPERTIES_SETTINGS_FORM_DATA_KEY = 'queryParameters';

export enum EReportPropertiesFieldTypes {
    INTEGER = 'INTEGER',
    NUMBER = 'NUMBER',
    STRING = 'STRING',
    DATE = 'DATE',
    DATETIME = 'DATETIME',
    BOOLEAN = 'BOOLEAN',
    VALUE_SET = 'VALUESET',
    MULTI_VALUE_SET = 'MULTIVALUESET',
    SQLVALUESET = 'SQLVALUESET',
    SQLMULTIVALUESET = 'SQLMULTIVALUESET',
    VALUERANGE = 'VALUERANGE',
}

export enum EReportPropertiesSettingsFormFields {
    paramName = 'paramName',
    columnName = 'columnName',
    reportTitle = 'reportTitle',
    visible = 'visible',
    required = 'required',
    type = 'type',
    // не трогать значение, так на бэке
    valuesetLookupType = 'valuesetLookupType',
    sqlValueset = 'sqlValueset',
    defaultType = 'defaultType',
    defaultValue = 'defaultValue',

    // доп поля, которые зависят от type, и в итоге трансформируются в defaultValue при сохранении
    defaultValueDate = 'defaultValueDate',
    defaultValueDateTime = 'defaultValueDateTime',
    defaultValueInteger = 'defaultValueInteger',
    defaultValueString = 'defaultValueString',
    defaultValueBoolean = 'defaultValueBoolean',
    defaultValueValueSet = 'defaultValueValueSet',
    defaultValueMultiValueSet = 'defaultValueMultiValueSet',
    defaultValueContext = 'defaultValueContext',
    defaultValueSqlValueSet = 'defaultValueSqlValueSet',
    defaultValueDateRange = 'defaultValueDateRange',

    format = 'format',
    inputRestrictions = 'inputRestrictions',
    periodLength = 'periodLength',
    ordinal = 'ordinal',
}

export interface IReportPropertiesSettingsDto {
    queryParameters: Record<EReportPropertiesSettingsFormFields, string | boolean>[];
}

export type TReportPropertySetting = IReportPropertiesSettingsDto['queryParameters'][0];

export const ReportPropertiesSettingsDefaultValueFields = [
    EReportPropertiesSettingsFormFields.defaultValueDate,
    EReportPropertiesSettingsFormFields.defaultValueDateTime,
    EReportPropertiesSettingsFormFields.defaultValueBoolean,
    EReportPropertiesSettingsFormFields.defaultValueInteger,
    EReportPropertiesSettingsFormFields.defaultValueString,
    EReportPropertiesSettingsFormFields.defaultValueContext,
    EReportPropertiesSettingsFormFields.defaultValueValueSet,
    EReportPropertiesSettingsFormFields.defaultValueMultiValueSet,
    EReportPropertiesSettingsFormFields.defaultValueSqlValueSet,
    EReportPropertiesSettingsFormFields.defaultValueDateRange,
];

export const ReportPropertiesSettingsFieldsResetDependencies = {
    [EReportPropertiesSettingsFormFields.type]: [
        ...ReportPropertiesSettingsDefaultValueFields,
        EReportPropertiesSettingsFormFields.defaultType,
        EReportPropertiesSettingsFormFields.valuesetLookupType,
        EReportPropertiesSettingsFormFields.format,
        EReportPropertiesSettingsFormFields.inputRestrictions,
        EReportPropertiesSettingsFormFields.periodLength,
    ],
    [EReportPropertiesSettingsFormFields.defaultType]:
        [
            ...ReportPropertiesSettingsDefaultValueFields,
            EReportPropertiesSettingsFormFields.valuesetLookupType,
        ],
    [EReportPropertiesSettingsFormFields.valuesetLookupType]:
        [EReportPropertiesSettingsFormFields.defaultValueValueSet,
            EReportPropertiesSettingsFormFields.defaultValueMultiValueSet,
        ],
};

export const FormatLookupSublistCodesMap = {
    [EReportPropertiesFieldTypes.DATE]: 'TABLE_REPORT_FORMAT_DATE',
    [EReportPropertiesFieldTypes.DATETIME]: 'TABLE_REPORT_FORMAT_DATE',
    [EReportPropertiesFieldTypes.INTEGER]: 'TABLE_REPORT_FORMAT_NUMBER',
    [EReportPropertiesFieldTypes.NUMBER]: 'TABLE_REPORT_FORMAT_NUMBER',
    [EReportPropertiesFieldTypes.VALUERANGE]: 'TABLE_REPORT_FORMAT_DATE',
};
